import * as React from 'react'
import { Textarea, type TextareaProps } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'

const ChatInput = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <Textarea
      autoComplete="off"
      ref={ref}
      name="message"
      className={cn(
        'max-h-12 w-full flex h-16 resize-none items-center rounded-md bg-white px-4 py-3 text-sm focus-visible:ring-ring focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 dark:bg-input/30',
        className
      )}
      {...props}
    />
  )
)
ChatInput.displayName = 'ChatInput'

export { ChatInput }
